import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group hover:border-primary-200/70 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={article.thumbnailUrl}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500">{article.publishedAt}</span>
        </div>
        <Link to={`/article/${article.slug}`}>
          <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2 line-clamp-2 hover:text-primary-600 transition-colors cursor-pointer">
            {article.title}
          </h3>
        </Link>
        <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">
          {article.summary}
        </p>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-user-line"></i>
            <span>{article.author}</span>
          </div>
          <Link
            to={`/article/${article.slug}`}
            className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            阅读全文
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}